import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    /* 本体,附件折扣数据 */
    spenum: 100,
    accnum: 100,
    /* 品牌、系列数据 */
    fdata: [],
    fid: 1,
    sid: 132,
    fname: "" /* 品牌名字 */,
    fsortname:'',/* 品牌简体名字 */
    shortname: "DZ47s" /* 系列简称 */,
    s: "",
    dusname: "" /* 品类名 */,
    defaultselect: [1, 3, 4, 10, 15, 29, 36, 41],
    sumprice: 12.44 /* 总价格 */,
    allname: "" /* 总名称 */,

    content: {},
    price: "",
  },
  mutations: {
    /* 本体,附件折扣数据 */
    spedisnum(state, data) {
      state.spenum = data;
    },
    accdisnum(state, data) {
      state.accnum = data;
    },
    /* 相似系列数据 */
    factdata(state, data) {
      state.fdata = data;
    },
    /* 品牌系列id */
    fid(state, data) {
      state.fid = data;
    },
    sid(state, data) {
      state.sid = data;
      // console.log(data);
    },
    fname(state, data) {
      state.fname = data;
    },
    fsortname(state,data){
      state.fsortname=data;

    },
    shortname(state, data) {
      state.shortname = data;
    },
    s(state, data) {
      state.s = data;
    },
    dusname(state, data) {
      state.dusname = data;
    },
    defaultselect(state, data) {
      state.defaultselect = data;
    },
    sumprice(state, data) {
      state.sumprice = data;
    },
    allname(state, data) {
      state.allname = data;
    },
    content(state, data) {
      state.content = data;
    },
    disprice(state, data) {
      state.price = data;
    },
  },
  actions: {},
  modules: {},
});

